import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import NotFound from './admin/404';

const RouteNotFound: FC = () => <Route component={NotFound} />;

export default RouteNotFound;
